import { grayscale, mix } from 'polished';

/**
 * Decreases the contrast between a color and background by a specified amount
 *
 * @param color: string - color to adjust
 * @param background:string - color of the background
 * @param amount:number - amount to adjust the luminance [0, 100]
 */
export const decreaseContrast = (color, background, amount) => {
  const grayscaleBackground = grayscale(background);
  const amountFraction = amount / 100;
  return mix(amountFraction, grayscaleBackground, color);
};
//# sourceMappingURL=decreaseContrast.js.map